export const isRequired = fieldName => `Это поле обязательно для ввода`;

export const mustMatch = otherFieldName => {
    return (fieldName) => `Пароли не совпадают. Повторите попытку`;
};

export const minLength = length => {
    return (fieldName) => `Поле "${fieldName}" должно содержать минимум ${length} символов`;
};

export const maxLength = length => {
    return (fieldName) => `Поле "${fieldName}" должно содержать не более ${length} символов`;
};

export const emailMatch = () => {
    return (fieldName) => `Поле "${fieldName}" должно содержать корректный e-mail адрес`;
};

export const alphaMatch = () => {
    return (fieldName) => `Поле "${fieldName}" содержит недопустимые символы, используйте только буквы, цифры, пробел и _`;
};



// WEBPACK FOOTER //
// ./src/validation/errorMessages.js